import { z } from 'zod';

export const deleteEvaluationSessionSchema = z.object({
  evaluation_session_id: z.uuid(),
});

export type DeleteEvaluationSessionPayload = z.infer<typeof deleteEvaluationSessionSchema>;
